/**
 * Ensure that provided value ends with provided string
 */
export const ensureEndsWith = (value: string, mustEndsWith: string) =>
  value.endsWith(mustEndsWith) ? value : `${value}${mustEndsWith}`;
